// extracted by mini-css-extract-plugin
export default {"passingWindow":"PassingWindow_passingWindow__vEril"};